import customId from "custom-id-new";
import { MSG_ID } from "../config/app";

export const msgId = () => customId({ randomLength: 8, lowerCase: true });
export const defaultMsgId = () => MSG_ID;
